import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { listUsers } from "../../actions/userActions";
import { ListProducts } from "../../actions/productAction";
import { ListCategorieswithoutpagination } from "../../actions/categoryAction";
import { orderNow } from "../../actions/orderActions";
import Axios from "../../axios/axios";
import Print from "./Print";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { PDFDownloadLink, Document, Page } from "@react-pdf/renderer";
import OrderPdf from "../Print/OrderPdf";
import { ToastContainer, toast } from "react-toastify";
import QRCode from "qrcode";

export default function NewOrder() {
  const dispatch = useDispatch();
  const userList = useSelector((state) => state.userList);
  const { loading, error, users } = userList;

  const today = new Date().toISOString().split("T")[0];

  const productList = useSelector((state) => state.productList);
  const { products } = productList;

  const orderNow_ = useSelector((state) => state.orderNow);
  const { success } = orderNow_;

  const catList = useSelector((state) => state.catList);
  const { categories } = catList;

  const [category, setCategory] = useState("");
  const [productList_, setProductList] = useState([]);

  const [customer, setCustomer] = useState("");
  const [product, setProduct] = useState("");
  const [orderQr, setOrderQr] = useState("");

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();

    const formattedMonth = month < 10 ? `0${month}` : month;
    const formattedDay = day < 10 ? `0${day}` : day;

    return `${year}-${formattedMonth}-${formattedDay}`;
  };

  const [startDate, setStartDate] = useState(getTodayDate());
  const [endDate, setEndDate] = useState(getTodayDate());
  const [days, setDays] = useState(1);
  const [qnty, setQnty] = useState(1);

  const [availability, setAvailability] = useState("");
  const [searchCustomer, setSearchCustomer] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);

  const [advance, setAdvance] = useState(0);
  const [discount, setDiscount] = useState(0);

  const [searchCustomerLoading, setCustomerLoading] = useState(false);
  const [searchCustomerRes, setResCustomer] = useState("");
  const [searchCustomerCode, setResCustomerCode] = useState("");
  const [customerDetails, setCustomerDetails] = useState();

  const [orderItem, setOrderItem] = useState(false);
  const [orderDetails, setOrderDetails] = useState();
  const [orderResponse, setOrderResponse] = useState();
  const [totalAmountVal, setTotalAMountVal] = useState(0);
  const [load, setLoad] = useState(false);
  const [showConflictModal, setShowConflictModal] = useState(false);
  const [conflictData, setConflictData] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("cash");

  // ✅ DEBUG LOGS
  console.log("Current State:", { startDate, endDate, days });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    dispatch(listUsers(""));
    dispatch(ListProducts({ pagination: false }));
    dispatch(ListCategorieswithoutpagination(""));
  }, [dispatch]);

  useEffect(() => {
    if (product) {
      let totQnt = days * parseInt(qnty);
      let prodSelected = productList_?.find((data) => data._id === product);
      let total = prodSelected?.offerPrice * totQnt;
      setTotalAMountVal(total);
    }
  }, [days, qnty, product]);

  useEffect(() => {
    handleNUmberOfDays(days, startDate);
  }, [days]);

  const onSubmit = async (e) => {
    e.preventDefault();

    const data = {
      customer,
      product,
      startDate,
      endDate,
      qnty,
    };

    console.log("Data being sent to API:", data);

    await Axios.post(`/api/order/check`, data).then((res) => {
      if (res.data.code === 200) {
        console.log("ORDER CHECK RESPONSE:", res.data);

        // if (res.data.balStock < qnty) {
        //   toast.error(`🦄 ${res.data.balStock} Stocks Available`, {
        //     position: "top-center",
        //     autoClose: 5000,
        //     hideProgressBar: false,
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: true,
        //     progress: undefined,
        //     theme: "light",
        //   });
        //   return;
        // }

        if (res.data.balStock < qnty) {
          toast.error(`🦄 ${res.data.balStock} Stocks Available`, {
            position: "top-center",
            autoClose: 3000,
          });

          // ✅ SHOW MODAL WITH DETAILS
          if (res.data.blockedBy && res.data.blockedBy.length > 0) {
            setConflictData(res.data.blockedBy);
            setShowConflictModal(true);
          }

          return;
        }

        let isStock = selectedItems?.find((data) => data.product === product);

        if (isStock) {
          toast.error(`Item Already added, Please remove and update new`, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        }

        setAvailability(res.data.code);

        let productDetail_ = products?.filter((data_) => data_._id === product);

        const date1 = new Date(startDate);
        const date2 = new Date(endDate);

        const timeDiff = Math.abs(date2 - date1);
        const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

        let calculatedDays = daysDiff === 0 ? 1 : daysDiff + 1;

        console.log("Date calculation:", {
          startDate,
          endDate,
          timeDiff,
          daysDiff,
          calculatedDays,
        });

        let amount = productDetail_[0]?.offerPrice * calculatedDays * qnty;

        console.log("Adding item to selectedItems:", {
          product,
          startDate,
          endDate,
          days: calculatedDays,
          amount,
        });

        const newArray = [...selectedItems];
        newArray.push({
          product,
          startDate, // ✅ Use state value directly
          endDate, // ✅ Use state value directly
          price: productDetail_[0]?.offerPrice,
          amount,
          days: calculatedDays,
          qnty,
          prodPrice: productDetail_[0]?.offerPrice,
        });
        setSelectedItems(newArray);
      } else {
        setAvailability(res.data.code);
      }
    });
  };

  const productName = (proId) => {
    let data = products.filter((data) => data._id === proId);
    return data[0]?.name;
  };

  const productPrice = (proId) => {
    let data = products.filter((data) => data._id === proId);
    return data[0]?.offerPrice;
  };

  const removeItems = (index) => {
    if (window.confirm("Do you want remove item")) {
      const newArray = [...selectedItems];
      newArray.splice(index, 1);
      setSelectedItems(newArray);
    }
  };

  const totalAmount = () => {
    let totalAmount_ = 0;

    selectedItems.map((data) => {
      let proId = data.product;
      let product_ = products.filter((data_) => data_._id === proId);

      // Calculate days from stored dates
      const date1 = new Date(data.startDate);
      const date2 = new Date(data.endDate);
      const timeDiff = Math.abs(date2 - date1);
      const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
      let days = daysDiff === 0 ? 1 : daysDiff + 1;

      let price = product_[0]?.offerPrice * days * parseInt(data.qnty);
      totalAmount_ = totalAmount_ + price;
    });

    return totalAmount_;
  };

  const totalAmountOfOrder = () => {
    let totalAmount_ = 0;
    selectedItems.map((data) => {
      totalAmount_ = totalAmount_ + data.amount;
    });
    return totalAmount_;
  };

  const bookNow = async (e) => {
    e.preventDefault();

    console.log("=== BOOKING ORDER ===");
    console.log("Selected Items:", selectedItems);

    if (advance > totalAmount()) {
      alert("Advance cannot be greater than total amount");
      return;
    }
    setLoad(true);

    let data = {
      customer,
      selectedItems,
      advance,
      orderAmount: totalAmount(),
      discount,
      paymentMethod,
      source: "admin",
    };

    await Axios.post(`/api/order/`, data).then((res) => {
      if (res.status === 200) {
        setOrderItem(true);
        setLoad(false);
        setOrderDetails(res.data.createdOrder);
        setOrderResponse("Saved Successfully");

        const qrText = JSON.stringify({
          orderId: res.data.createdOrder.orderId,
          customerName: searchCustomerRes,
          customerNumber: searchCustomer,
        });

        QRCode.toDataURL(qrText).then(async (url) => {
          setOrderQr(url);
          await Axios.put(`/api/order/update-qr/${res.data.createdOrder._id}`, {
            qrCode: url,
          });
        });
      }
    });
  };

  const calculateBalance = () => {
    let adv = advance || 0;
    let dis = discount || 0;
    let amount = parseInt(adv) + parseInt(dis);
    let bal = totalAmount() - amount;
    return bal;
  };

  const customerSearchFunction = async (e) => {
    if (e.keyCode === 13) {
      setSearchCustomer(e.target.value);
      if (e.target.value === "") {
        setResCustomer("Please enter mobile number");
      } else {
        setCustomerLoading(true);
        const { data } = await Axios.get(`/api/user/mob/${e.target.value}`);
        setResCustomerCode(data.code);

        if (data.code === 400) {
          setCustomerLoading(false);
          setResCustomer(data.message);
        } else {
          setCustomerLoading(false);
          setResCustomer(data.user.name);
          setCustomer(data.user._id);
          setCustomerDetails(data);
        }
      }
    }
  };

  // ✅ FIXED: Ensure dates are always calculated correctly
  const handleNUmberOfDays = (val, date_) => {
    console.log("handleNUmberOfDays called with:", { val, date_ });

    setDays(val);

    if (date_) {
      const startDate_ = new Date(date_);
      startDate_.setHours(0, 0, 0, 0);

      // If days = 1, both start and end are the same
      if (parseInt(val, 10) === 1) {
        console.log("Setting dates for 1 day - both same:", date_);
        setEndDate(date_);
      } else {
        // For multi-day rentals, add (days - 1) to start date
        startDate_.setDate(startDate_.getDate() + parseInt(val, 10) - 1);

        const year = startDate_.getFullYear();
        const month = startDate_.getMonth() + 1;
        const day = startDate_.getDate();

        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;

        const date = `${year}-${formattedMonth}-${formattedDay}`;
        console.log("Setting end date for multi-day:", date);
        setEndDate(date);
      }
    }
  };

  const handleStartDate = (val) => {
    console.log("Start date changed to:", val);
    setStartDate(val);
    handleNUmberOfDays(days, val);
  };

  const changeCategory = (val) => {
    setCategory(val);
    const data = products.filter((data) => data?.category?._id === val);
    setProductList(data);
  };

  return (
    <div className="card p-3">
      <div>
        <form onSubmit={onSubmit}>
          <div className="row">
            <div className="col-md-6 col-sm-12 grid-margin transparent">
              <div className="row">
                <div className="col-md-6 mb-4 stretch-card transparent">
                  <div className="card card-tale">
                    <div className="card-body">
                      <p className="mb-4">Customer</p>

                      <div className="d-flex">
                        <div className="p-2">
                          <input
                            type="search"
                            className="form-control"
                            placeholder="Search by Mobile Number and press enter"
                            onKeyDown={(e) => customerSearchFunction(e)}
                          />
                        </div>
                      </div>
                      <div>
                        {searchCustomerLoading === true ? (
                          <div className="spinner-border ml-5" role="status">
                            <span className="sr-only ">Loading...</span>
                          </div>
                        ) : (
                          <span>
                            {searchCustomerRes}
                            {searchCustomerCode === 400 && (
                              <Link to="/user/create">Create customer </Link>
                            )}
                          </span>
                        )}
                      </div>

                      <select
                        className="form-control mt-3"
                        required
                        value={category}
                        onChange={(e) => changeCategory(e.target.value)}
                      >
                        <option value="">Select Category</option>

                        {categories
                          ?.slice() // ✅ avoid mutating Redux state
                          .sort((a, b) =>
                            a.categoryName.localeCompare(b.categoryName),
                          )
                          .map((data) => (
                            <option key={data._id} value={data._id}>
                              {data.categoryName}
                            </option>
                          ))}
                      </select>

                      <select
                        className="form-control mt-1"
                        required
                        value={product}
                        onChange={(e) => setProduct(e.target.value)}
                      >
                        <option value="">Select Product</option>
                        {productList_?.map((data) => (
                          <option key={data._id} value={data._id}>
                            {data.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-12 mb-4 stretch-card transparent">
                  <div className="card card-tale">
                    <div className="card-body">
                      <p className="mb-4">Start Date</p>
                      <input
                        type="date"
                        className="form-control"
                        required
                        value={startDate}
                        min={today}
                        onChange={(e) => handleStartDate(e.target.value)}
                      />
                      <div className="row">
                        <div className="col-6">
                          <p className="mb-1">Days</p>
                          <input
                            type="number"
                            className="form-control"
                            required
                            value={days}
                            min={1}
                            onChange={(e) =>
                              handleNUmberOfDays(e.target.value, startDate)
                            }
                            disabled={startDate === "" ? true : false}
                          />
                        </div>
                        <div className="col">
                          <p className="mb-1">End Date</p>
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "black",
                            }}
                          >
                            {endDate}
                          </span>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <p className="mb-1">Qnt</p>
                          <input
                            type="number"
                            className="form-control"
                            required
                            value={qnty}
                            min={1}
                            onChange={(e) => setQnty(e.target.value)}
                            disabled={startDate === "" ? true : false}
                          />
                        </div>
                        <div className="col">
                          <p className="mb-1">Total Price</p>
                          <span
                            style={{
                              fontSize: "20px",
                              fontWeight: "500",
                              color: "black",
                            }}
                          >
                            ₹{totalAmountVal}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div>
                  <button
                    type="submit"
                    className="btn btn-secondary btn-lg btn-block mr-5"
                  >
                    Add
                    <i className="ti-plus float-right"></i>
                  </button>
                </div>

                {availability === 200 && (
                  <div
                    className="alert alert-success alert-dismissible fade show mt-2"
                    role="alert"
                  >
                    <strong>Item Added!</strong> Items available for this date
                    <button
                      type="button"
                      className="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                )}
                {availability === 400 && (
                  <div
                    className="alert alert-Danger alert-dismissible fade show mt-2"
                    role="alert"
                  >
                    <strong>Not Available!</strong> Items not available for this
                    date
                    <button
                      type="button"
                      className="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                )}
                {availability === 402 && (
                  <div
                    className="alert alert-Danger alert-dismissible fade show mt-2"
                    role="alert"
                  >
                    <strong>Not Available!</strong> Stock not available
                    <button
                      type="button"
                      className="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-6  grid-margin stretch-card card p-3">
              <div
                className="table-responsive"
                style={{
                  maxHeight: "65vh",
                  overflowY: "auto",
                  display: "block",
                }}
              >
                <p style={{ fontWeight: "bold" }}>Selected Items</p>
                <table
                  className="display expandable-table"
                  style={{ width: "100%" }}
                >
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      background: "#fff",
                      zIndex: 1,
                    }}
                  >
                    <tr>
                      <th>Number</th>
                      <th>Product</th>
                      <th>S Date</th>
                      <th>Days</th>
                      <th>Qnt</th>
                      <th>Price</th>
                      <th>Net</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedItems && selectedItems.length > 0 ? (
                      selectedItems?.map((data, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{productName(data.product)}</td>
                          <td>{data.startDate}</td>
                          <td>{data.days}</td>
                          <td>{data.qnty}</td>
                          <td>₹ {productPrice(data.product)}</td>
                          <td>
                            ₹{" "}
                            {productPrice(data.product) * data.days * data.qnty}
                          </td>
                          <td>
                            <i
                              className="mdi mdi-close-octagon-outline"
                              style={{ color: "red", cursor: "pointer" }}
                              onClick={(e) => removeItems(index)}
                            ></i>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center text-black">
                          No Items Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </form>
        <div className="row">
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-4 col-lg-2 mb-2">
                    <label>Discount</label>
                    <input
                      type="number"
                      className="form-control mb-2"
                      placeholder="Discount"
                      value={discount}
                      min={0}
                      onChange={(e) => setDiscount(e.target.value)}
                    />
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-2 mb-2">
                    <label>Advance</label>
                    <input
                      type="number"
                      className="form-control mb-2"
                      placeholder="Advance Amount"
                      value={advance}
                      min={0}
                      onChange={(e) => setAdvance(e.target.value)}
                    />
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-2 mb-2">
                    <label>Payment Method</label>
                    <select
                      className="form-control"
                      value={paymentMethod}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                    >
                      <option value="cash">Cash</option>
                      <option value="upi">UPI</option>
                    </select>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 col-lg-2 mb-2">
                    {load ? (
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden"></span>
                      </div>
                    ) : (
                      <>
                        <div> Balance : {totalAmountOfOrder()}</div>
                        <button
                          type="button"
                          className="btn btn-success mt-2"
                          data-toggle="modal"
                          data-target="#bookNowModal"
                          disabled={selectedItems.length === 0 ? true : false}
                        >
                          Book Now
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="bookNowModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="bookNowModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <form className="forms-sample">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="bookNowModalLabel">
                  {orderResponse ? orderResponse : "Summary"}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              {orderItem === true ? (
                <div className="modal-body" id="divToPrint">
                  <Print
                    customerName={searchCustomerRes}
                    customerNumber={searchCustomer}
                    address={customerDetails?.user?.address1}
                    invoiceId={orderDetails.orderId}
                    orderDate={orderDetails.createdAt}
                    advance={advance}
                    amount={totalAmountOfOrder()}
                    items={selectedItems}
                    discount={discount}
                    specialPrice={orderDetails?.specialPrice}
                  />
                </div>
              ) : (
                <div className="modal-body">
                  <div className="table-responsive">
                    <table className="table table-striped table-borderless">
                      <thead>
                        <tr>
                          <th>Sl No</th>
                          <th>Items</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedItems.map((data, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{productName(data.product)}</td>
                            <td>{data.startDate}</td>
                            <td>{data.endDate}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="mt-4">
                    Total Price : ₹
                    {selectedItems.length === 0 ? 0 : totalAmountOfOrder()}
                  </div>
                </div>
              )}
              <div className="modal-footer">
                <a href="/orders">
                  <button type="button" className="btn btn-secondary">
                    Close
                  </button>
                </a>
                {load ? (
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden"></span>
                  </div>
                ) : (
                  <div className="bottom-area">
                    <div>
                      {orderItem === true ? (
                        <PDFDownloadLink
                          document={
                            <OrderPdf
                              products={products}
                              customerName={searchCustomerRes}
                              customerNumber={searchCustomer}
                              address={customerDetails?.user?.address1}
                              invoiceId={orderDetails.orderId}
                              orderDate={orderDetails.createdAt}
                              advance={advance}
                              amount={totalAmountOfOrder()}
                              items={selectedItems}
                              discount={discount}
                              specialPrice={orderDetails?.specialPrice}
                              orderQr={orderQr}
                            />
                          }
                          fileName={`${searchCustomerRes}Order.pdf`}
                        >
                          {({ blob, url, loading, error }) => (
                            <button type="button" className="btn btn-primary">
                              download pdf
                            </button>
                          )}
                        </PDFDownloadLink>
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-primary"
                          onClick={bookNow}
                        >
                          Save changes
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
      <ToastContainer />
      {showConflictModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 10,
              padding: 25,
              width: 550,
              maxWidth: "95%",
              boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
            }}
          >
            <h4 style={{ marginBottom: 15, color: "#dc3545" }}>
              ❌ Stock Not Available
            </h4>

            <p style={{ marginBottom: 15 }}>
              This product is already booked in the following order(s):
            </p>

            <div className="table-responsive">
              <table className="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Customer</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Overlap Dates</th>
                    <th>Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {conflictData.map((item, idx) => (
                    <tr key={idx}>
                      <td>ADC_{item.orderId}</td>
                      <td>{item.customerName || "—"}</td>
                      <td>{item.startDate}</td>
                      <td>{item.endDate}</td>
                      <td>
                        {item.overlapStart} → {item.overlapEnd}
                      </td>{" "}
                      <td>{item.qnty}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div style={{ textAlign: "right", marginTop: 20 }}>
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowConflictModal(false);
                  setConflictData([]);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
